export default function isEmptyValue(variable) {
  return variable === undefined || variable === null || variable === "";
}
